import React, { Fragment, Component } from 'react';
import DocumentTitle from 'react-document-title';
import { Icon } from 'antd';
import GlobalFooter from "components/GlobalFooter";
import styles from './UserLayout.module.less';
import logo from 'assets/logo.svg';
import { RouterLink } from "mobx-state-router";

const links = [{
  key: 'help',
  title: 'Help',
  href: '',
}, {
  key: 'privacy',
  title: 'Privacy',
  href: '',
}, {
  key: 'terms',
  title: 'Terms',
  href: '',
}];

const copyright = <Fragment>Copyright <Icon type="copyright" /> 2018 RankerX</Fragment>;

class UserLayout extends Component {
  getPageTitle() {
    // const { routerData, location } = this.props;
    // const { pathname } = location;
    // let title = 'RankerX';
    // if (routerData[pathname] && routerData[pathname].name) {
    //   title = `${routerData[pathname].name} - RankerX`;
    // }
    // return title;
    return "RankerX";
  }
  render() {    
    return (
      <DocumentTitle title={this.getPageTitle()}>
        <div className={styles.container}>
          <div className={styles.content}>
            <div className={styles.top}>
              <div className={styles.header}>
                <RouterLink routeName="campaigns">
                  <img alt="logo" className={styles.logo} src={logo} />
                  <span className={styles.title}>RankerX</span>
                </RouterLink>
              </div>
              <div className={styles.desc}>RankerX Best SEO software</div>
            </div>
            {this.props.children}
          </div>
          <GlobalFooter links={links} copyright={copyright} />
        </div>
      </DocumentTitle>
    );
  }
}

export default UserLayout;
